const openTirePopupBtn = document.querySelector('#open-tire-popup');
const closeTirePopupBtn = document.querySelector('#close-tire-popup');
const tirePopup = document.querySelector('.singleTirePopup');

const TOGGLED_POPUP_CLASS = 'singleTirePopup--opened';

const togglePopup = () => {
    tirePopup.classList.toggle(TOGGLED_POPUP_CLASS);
};

if (openTirePopupBtn && closeTirePopupBtn && tirePopup) {
    openTirePopupBtn.addEventListener('click', togglePopup);
    closeTirePopupBtn.addEventListener('click', togglePopup);
}
